import usePodcastFormStepsStore from 'store/usePodcastFormStepsStore'

export const SubmitSummary = () => {
  const { submission, podcast } = usePodcastFormStepsStore()
  return (
    <div className="border-t border-gray-100">
      <dl className="divide-y divide-gray-100">
        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-900">Show Name</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            {podcast.show_name}
          </dd>
        </div>
        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-900">Speakers</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            {(podcast.speakers as string[]).join(', ')}
          </dd>
        </div>
        {/* <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-900">
            Custom Vocabulary
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            {podcast.word_boost?.map((word) => word).join(', ')}
          </dd>
        </div> */}
        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Filename
          </dt>
          <dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
            {submission.filename}
          </dd>
        </div>
      </dl>
    </div>
  )
}
